import { LinkButtonWithIcon } from "@/components/Buttons/LinkButtonWithIcon"
import ConfidentialLines from "@/components/ConfidentialLines"
import { ContactDetailsAddress } from "@/components/ContactDetail"
import { TagIcon } from "@/components/Icons"
import { EyeIcon } from "@/components/Icons"
import { SheetField, SheetFieldGrid, SheetSection } from "@/components/Sections/SheetSection"
import { getDefaultContactDetails } from "@/domain/contactdetails/getContactDetails"
import { getDisplayedName } from "@/domain/property/getDisplayedName"
import { getProjectOfferLinkSheet } from "@/domain/propertyOffer/getProjectOfferLinkSheet"
import { NIL_UUID } from "@/domain/resources/constants"
import {
  type SharedDataJsonldReadCollectionSharedDataProject,
  useGetProject,
} from "@/networking/api"
import { EMPTY_PLACEHOLDER } from "@/utils/constants"
import { isNotNullNorUndefined } from "@/utils/ts-utils"
import { useIntl } from "react-intl"
import { useNavigate } from "react-router-dom"

type Props = {
  project: SharedDataJsonldReadCollectionSharedDataProject
}

export const ProjectSection = ({ project }: Props) => {
  const intl = useIntl()
  const isShared = project?.isShared ?? false
  const navigateTo = useNavigate()

  const { data: projectDetails } = useGetProject(project?.id ?? NIL_UUID)
  const property = projectDetails?.propertyOffer?.[0]?.property
  const projectName = isNotNullNorUndefined(property)
    ? getDisplayedName(property, intl, undefined, isShared)
    : intl.formatMessage({ id: "undefined" })
  const contactDetails = getDefaultContactDetails(property?.contactDetails)

  return (
    <SheetSection
      title={intl.formatMessage({ id: "userSharedData.project.details" })}
      icon={TagIcon}
      isFirst
    >
      <SheetFieldGrid>
        <SheetField label={intl.formatMessage({ id: "userSharedData.project.name" })}>
          {projectName}
          <LinkButtonWithIcon
            display="inline-block"
            ml="2"
            icon={EyeIcon}
            onClick={() => navigateTo(getProjectOfferLinkSheet(project))}
          />
        </SheetField>
        {project?.isShared ? (
          <SheetField label={intl.formatMessage({ id: "userSharedData.project.geoloc" })}>
            <ContactDetailsAddress contactDetails={contactDetails} dft={EMPTY_PLACEHOLDER} />
          </SheetField>
        ) : (
          <SheetField label={intl.formatMessage({ id: "userSharedData.project.geoloc" })}>
            <ConfidentialLines nbOfLines={2} />
          </SheetField>
        )}
      </SheetFieldGrid>
    </SheetSection>
  )
}
